import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Music, Loader2 } from "lucide-react";
import { motion } from "framer-motion";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState(() => localStorage.getItem('remembered_email') || '');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      localStorage.setItem('remembered_email', email);
      await login(email, password);
      navigate('/dashboard');
    } catch (err) {
      setError(err.response?.data?.detail || 'Erreur de connexion');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
        className="bg-white rounded-3xl shadow-[0_10px_60px_rgba(44,53,49,0.06)] border border-[#EBE7E0] p-8 sm:p-10 w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="w-16 h-16 bg-[#6B8576] rounded-3xl flex items-center justify-center mx-auto mb-5">
            <Music className="w-7 h-7 text-white" strokeWidth={1.5} />
          </div>
          <h1 className="text-2xl font-semibold text-[#2C3531]" style={{ fontFamily: 'Outfit' }}>Audio Sur Mesure</h1>
          <p className="text-[#6A7771] text-sm mt-1.5">Votre espace personnel de bien-être</p>
        </div>

        {error && <div className="bg-red-50 text-[#B86666] p-3.5 rounded-2xl text-sm mb-5 border border-red-100" data-testid="login-error">{error}</div>}

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-sm font-medium text-[#2C3531] mb-1.5">Email</label>
            <input type="email" className="w-full px-4 py-3 rounded-2xl border border-[#EBE7E0] bg-[#FAF9F6] focus:outline-none focus:ring-2 focus:ring-[#6B8576]/20 focus:border-[#6B8576] transition-all duration-300" value={email} onChange={e => setEmail(e.target.value)} required data-testid="login-email" />
          </div>
          <div>
            <label className="block text-sm font-medium text-[#2C3531] mb-1.5">Mot de passe</label>
            <input type="password" className="w-full px-4 py-3 rounded-2xl border border-[#EBE7E0] bg-[#FAF9F6] focus:outline-none focus:ring-2 focus:ring-[#6B8576]/20 focus:border-[#6B8576] transition-all duration-300" value={password} onChange={e => setPassword(e.target.value)} required data-testid="login-password" />
            <div className="text-right mt-1.5">
              <Link to="/forgot-password" className="text-xs text-[#6B8576] hover:underline" data-testid="forgot-password-link">Mot de passe oublié ?</Link>
            </div>
          </div>
          <button type="submit" disabled={loading} className="w-full py-3 bg-[#6B8576] text-white rounded-full font-medium hover:bg-[#546A5E] transition-all duration-300 disabled:opacity-50 text-sm" data-testid="login-submit">
            {loading ? <Loader2 className="w-5 h-5 animate-spin mx-auto" /> : 'Se connecter'}
          </button>
        </form>
        <p className="text-center text-sm text-[#6A7771] mt-7">Pas encore de compte ? <Link to="/register" className="text-[#6B8576] font-medium hover:underline">S'inscrire gratuitement</Link></p>
      </motion.div>
    </div>
  );
}
